import auth from '@/middleware/modules/auth'
import internalStaff from '@/middleware/modules/internalStaff'

const VirtualInfluencers = () => import(/* webpackChunkName: "_v-virtual-influencers" */ '@/views/virtual-influencers/Index.vue')

// Route name is prefixed `myCreators-` so menu.vue's existing
// handleRouteChange() `^myCreators*` branch opens the My Creators section.
export default [
  {
    path: 'myCreators/virtual-influencers',
    name: 'myCreators-virtual-influencers',
    component: VirtualInfluencers,
    meta: {
      layout: 'app-layout',
      middleware: [auth, internalStaff],
      breadcrumbs: ['campaigns'],
    },
  },
]
